import React, { useEffect, useState } from 'react';
import RangeSliderField from './range-slider-field';

type CostSliderType = {
  update: (val) => void;
  defaultMin: number;
  defaultMax: number;
  maxValue?: number;
  label?: string;
};

const formatPrice = (price: number) => `£${price.toFixed(1)}m`;

const CostSlider = ({
  update,
  defaultMin,
  defaultMax,
  maxValue,
  label = 'Player Price'
}: CostSliderType) => {
  const [costRange, setCostRange] = useState<[number, number]>([
    defaultMin,
    defaultMax
  ]);

  useEffect(() => {
    if (!maxValue) {
      return;
    }

    if (maxValue < costRange[1]) {
      setCostRange([costRange[0], maxValue]);
    } else {
      setCostRange([defaultMin, defaultMax]);
    }
  }, [maxValue]);

  function handleRangeCommit(value: [number, number]) {
    setCostRange(value);
    update(value);
  }

  return (
    <RangeSliderField
      label={label}
      name="cost-slider"
      onCommit={handleRangeCommit}
      min={defaultMin}
      max={defaultMax}
      step={0.1}
      value={costRange}
      formatLabel={formatPrice}
      // Fits £15.0m.
      pillMinWidthClassName="!min-w-[62px]"
    />
  );
};

export default CostSlider;
